/**
 * 人工客服的用户信息集
 *
 * 对于人工客服头像的获取，与 community-h5 处理方式不同
 * community-h5 是在初始化时一次性获取所有人工客服的信息
 * 而现在是按需加载，即仅请求消息列表存在那些人工客服的信息
 */

import { getServiceUserInfo } from '@/api/chat'
import eventBus from '@/event_bus'

class HumanUsers {
    constructor () {
        this.users = {}
    }

    /**
     * @param { String } id
     * @param { Boolean | Object } [value = false] - Boolean 代表请求状态，Object 代表用户信息对象
     * 其中，false 表示待请求，true 表示正在请求
     */
    add (id, value = false) {
        if (this.has(id)) {
            return
        }
        this.set(id, value)
        this.load()
    }

    /**
     * @param { String } id
     * @param { Boolean | Object } value - Boolean 代表请求状态，Object 代表用户信息对象
     */
    set (id, value) {
        this.users[id] = value
    }

    /**
     * @param { String } id
     * @returns { Object | Boolean | Undefined }
     */
    get (id) {
        return this.users[id]
    }

    /**
     * @param { String } id
     * @returns { Boolean }
     */
    has (id) {
        return id in this.users
    }

    load () {
        for (const id in this.users) {
            const value = this.get(id)

            if (value === false) {
                this.set(id, true)
                getServiceUserInfo(id)
                    .then(user => {
                        this.set(id, user)
                        eventBus.setHumanUsers(this.users)
                    })
                    .catch(err => {
                        // eslint-disable-next-line
                        console.error(err)
                        this.set(id, false)
                    })
            }
        }
    }
}

export default new HumanUsers()
